import { React, Component, Container, _ } from 'utils';
import { QualificationStore, Creators } from 'model';
import QualificationFilter from './QualificationFilter';
import ExperienceRange from './ExperienceRange';
import LanguagesFilter from './LanguagesFilter';

class EqFilters extends Component {

	static getStores() {
		return [QualificationStore];
	}

	static calculateState() {
		return QualificationStore.getState();
	}

	handleResetQualifications() {
		Creators.resetQualifications();
	}

	handleResetLanguages() {
		Creators.resetLanguages();
	}

	handleResetLanguageLevel() {
		Creators.resetLanguageLevel();
	}

	handleResetExperience() {
		Creators.resetExperience();
	}

	handleResetJobTypes() {
		Creators.resetJobTypes();
	}

	handleResetDriverLicense() {
		Creators.resetDriverLicenseTypes();
	}

	handleResetManager() {
		Creators.resetManagerExpirience()
	}

	handleDoFilter() {
		Creators.applyFilters(QualificationStore.filterState);
	}

	handleToggleCollapse(e, idx) {
		// Toggle _mannualy_ so that we can prevent propagation
		// when user presses "reset filter" button
		$(this[`collapsible${idx}`]).collapse('toggle')

		const $chevronIcon = $(e.currentTarget)
			.find('.panel-collaps-arrow i');

		if ($chevronIcon.hasClass('fa-chevron-up')) 
		{
			$chevronIcon
				.removeClass('fa-chevron-up')
				.addClass('fa-chevron-down');
		}
		else
		{
			$chevronIcon
				.removeClass('fa-chevron-down')
				.addClass('fa-chevron-up');
		}
	}

	renderFilterPanels(panels) {
		return panels.map(({ component, title, resetHandler, selected, opened }, idx) => (
			<div className="panel-group" key={`__collapsable-key-${idx}`}>
				<div className="panel panel-default">

					{/**************** Header ****************/}
					<div
						className="panel-heading"
						onClick={(e) => this.handleToggleCollapse(e, idx)}
					>
						<h4 className="panel-title">
							<b>{title}</b>{/* selected ? ` (${selected})` : null */}
							{' '}
							<span
								className="fa-box"
								onClick={(e) => {
									e.stopPropagation();
									resetHandler(); 
								}}
							>
								<i className="fa fa-rotate-left"></i>
							</span>
						</h4>

						<div className="panel-collaps-arrow">
							<i className={`fa fa-chevron-${opened ? "up" : "down"}`} aria-hidden="true"></i>
						</div>
					</div>
					
					{/**************** Body ****************/}
					<div
						ref={node => this[`collapsible${idx}`] = node}
						className={`panel-collapse ${!opened ? "collapse" : "collapse in"}`}
					>
						<div className="panel-body">
							{component}
						</div>
					</div>


				</div>
			</div>
		));
	}

	render() {
		const { qualifications, toggle, languages, jobTypes, driverLicensceTypes, managersExpiriences } = this.state;

		const QualifiactionsList = qualifications.map((item, index) => (
			<QualificationFilter
				key={index}
				model={item}
				filterName="qualifications"
			/>
		));
		const LanguagesList = languages.map((item, index) => (
			<LanguagesFilter
				key={index}
				model={item}
				filterName="languages"
				toggle ={toggle}
			/>
		));
		const JobTypesList = jobTypes.map((item, index) => (
			<QualificationFilter
				key={index}
				model={item}
				filterName="jobTypes"
			/>
		));

		const DriverLicencesList = driverLicensceTypes.map((item, index) => (
			<QualificationFilter
				key={index}
				model={item}
				filterName="driverLicensceTypes"
			/>
		));

		const YearsExpirience = (
			<div className="range-slider">
				<h6>{_('Godina')}</h6>
					<ExperienceRange />
				<div className="clearfix"></div>
			</div>
		);

		const ManagementExpirience = (
			<QualificationFilter 
				key={'test'}
				model={{ 
					name: _('Potrebno managersko iskustvo i vještine'),
					selected: managersExpiriences,
				}}
				filterName="managersExpiriences"
			/>
		);

		const FilterComponents = this.renderFilterPanels([
			{ 
				component: YearsExpirience,
				title: _('Radno iskustvo'),
				resetHandler: this.handleResetExperience,
				opened: true,
			},
			{
				component: LanguagesList,
				title: _('Strani jezik'),
				resetHandler: this.handleResetLanguages,
				selected: languages.filter(item => item.selected).length,
				opened: false,
			},
			{
				component: QualifiactionsList,
				title: _('Obrazovanje'), 
				resetHandler: this.handleResetQualifications,
				selected: qualifications.filter(item => item.selected).length,
				opened: qualifications.filter(item => item.selected).length,
			},
			{ 
				component: JobTypesList,
				title: _('Vrsta zaposlenja'),
				resetHandler: this.handleResetJobTypes,
				selected: jobTypes.filter(item => item.selected).length,
				opened: false,
			},
			{
				component: DriverLicencesList,
				title: _('Vozačka dozvola'),
				resetHandler: this.handleResetDriverLicense,
				selected: driverLicensceTypes.filter(item => item.selected).length,
				opened: false,
			},
			{
				component: ManagementExpirience,
				title: _('Ostale vještine'),
				resetHandler: this.handleResetManager,
				opened: false,
			},
		]);

		return (
			<div className="eq-filters">
				{FilterComponents}
				<input
					type="button"
					className="btn btn-primary btn-block"
					onClick={this.handleDoFilter}
					value={_('Filtriraj')}
				/>
			</div>
		);
	}
}

const eqContainer = Container.create(EqFilters);
export default eqContainer;


// WEBPACK FOOTER //
// ./src/modules/app/filters/EqFilters.js